import Abstract from 'classes/Abstract.js';
class ContentManager {

    subscribers = {};

    fetch = type => {
        Object.values(this.subscribers).forEach(subscriber => {

            // check for valid callback for subscriber
            let { onFetch } = subscriber.callbacks;
            if(typeof(onFetch) !== 'function') {
                return;
            }

            // find types for subscriber
            // subscriber type could be string of array of strings
            let subscriber_types = Array.isArray(subscriber.type) ? subscriber.type : [ subscriber.type ];
            subscriber_types.forEach(subscriber_type => {

                // find types for emitter
                // emitter type could be string of array of strings
                let emitter_types = Array.isArray(type) ? type : [ type ];
                if(emitter_types.includes(subscriber_type)) {
                    onFetch(subscriber_type);
                }
            })
        })
    }

    subscribe = (id, type, callbacks) => {
        this.subscribers[id] = {
            type: type,
            callbacks: callbacks
        };
    }

    unsubscribe = id => {
        delete this.subscribers[id];
    }

    update = abstract => {
        Object.values(this.subscribers).forEach(subscriber => {

            // check for valid callback for subscriber
            let { onUpdate } = subscriber.callbacks;
            if(typeof(onUpdate) !== 'function') {
                return;
            }

            // find types for subscriber
            // subscriber type could be string of array of strings
            let subscriber_types = Array.isArray(subscriber.type) ? subscriber.type : [ subscriber.type ];
            subscriber_types.forEach(subscriber_type => {

                // find types for emitter
                // emitter type could be string of array of strings
                if(abstract.type === subscriber_type) {
                    onUpdate(Abstract.create({ ...abstract }));
                }
            })
        })
    }
}

export default {
    new: () => new ContentManager()
};
